import { Controller, useFormContext } from 'react-hook-form'
import { CurecallInput, CurecallTextarea } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'
import { useEffect, useRef } from 'react'
import { TChatbotGeneralFormValues } from './chatbot-form.type'

export function ChatbotNameFields() {
  const { t } = useTranslation()
  const {
    formState: { errors },
    control,
  } = useFormContext<TChatbotGeneralFormValues>()
  const nameInputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    nameInputRef.current?.focus()
  }, [])

  return (
    <>
      <Controller
        control={control}
        name="name"
        rules={{ required: true }}
        render={({ field }) => (
          <CurecallInput
            ref={nameInputRef}
            label={t('pages.configuration.followups.chatbot.general-form.agent-name')}
            placeholder={t('pages.configuration.followups.chatbot.general-form.agent-name-placeholder')}
            value={field.value}
            onChange={field.onChange}
            isRequired={true}
            errorMessage={errors.name && t('common.form.required')}
            tooltipContent={t('pages.configuration.followups.chatbot.general-form.agent-name-tooltip')}
            tooltipPosition="right"
            wrapperClassName="c-w-full"
          />
        )}
      />

      <Controller
        control={control}
        name="description"
        render={({ field }) => (
          <CurecallTextarea
            label={t('pages.configuration.followups.chatbot.general-form.agent-description')}
            placeholder={t(
              'pages.configuration.followups.chatbot.general-form.agent-description-placeholder',
            )}
            value={field.value ?? ''}
            onChange={field.onChange}
            errorMessage={errors.description && t('common.form.required')}
            tooltipContent={t('pages.configuration.followups.chatbot.general-form.agent-description-tooltip')}
            tooltipPosition="right"
            wrapperClassName="c-w-full"
            textareaClassName="tw-h-16 !c-font-light"
          />
        )}
      />
    </>
  )
}
